/**
 * Created by liuyinghui on 20/9/1.
 */
import Vue from 'vue';
import Vuex from 'vuex';

Vue.use(Vuex)

const state = {
	abortH5:{
		isShowH5: 0,
		language: "zh_cn",
		appId: "",
		appName:"",
		accountId:0,
		/*
		* custom:"1": 默认进入FAQ列表页面，点击“联系客服”直接进入人工客服页面 
		* custom:"2": 默认进入人工客服页面 
		* custom:"3": 默认进入机器人客服页面
		*  custom:"4": 默认进入机器人客服页面，并且不显示页面左下角的“联系客服”入口
		*  custom:"5": 默认进入FAQ列表页面，并且不显示“联系客服”入口
		*
		* */
		custom: '3' // 此处需求要求使用3
	}
}

const mutations = {
	CHANGELANGUAGE(state, language){
		state.abortH5.language = language;
		// elvah5.conf.language = language;
	},
	CHANGEISSHOWH5(state, isShowH5){
		state.abortH5.isShowH5 = isShowH5;
	},
	CHANGEAPPID(state, appId){
		state.abortH5.appId = appId;
	},
	CHANGEAPPNAME(state, appName){
		state.abortH5.appName = appName;
	},
	CHANGEACCOUNTID(state, accountId){
		state.abortH5.accountId = accountId;
	}
}

// const store = new Vuex.Store({
// 	state: state,
// 	mutations: mutations,
// })
//
//
// export default store;

export default new Vuex.Store({
	state,
	mutations,
});